import { z } from 'zod'

export const validationResponseSchema = z
  .object({
    schemaVersion: z.literal(1),
    status: z.enum([
      'PENDING',
      'RUNNING',
      'PASSED',
      'FAILED',
      'RECONCILIATION_REQUIRED',
    ]),
    messaging: z.enum([
      'CHECKING',
      'PASSED',
      'NEEDS_ATTENTION',
      'NOT_REQUESTED',
    ]),
    voice: z.enum(['CHECKING', 'PASSED', 'NEEDS_ATTENTION', 'NOT_REQUESTED']),
    lastCheckedAt: z.number().int().nonnegative().nullable(),
    canContinue: z.boolean(),
  })
  .strict()

export type ValidationResponse = z.infer<typeof validationResponseSchema>

export const activationResponseSchema = z
  .object({
    schemaVersion: z.literal(1),
    status: z.literal('READY'),
    revision: z.number().int().positive(),
  })
  .strict()

export type ActivationResponse = z.infer<typeof activationResponseSchema>
